var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7918 9.2085H24.806M9.91683 2.8335H24.0835C27.9955 2.8335 31.1668 6.00481 31.1668 9.91683V24.0835C31.1668 27.9955 27.9955 31.1668 24.0835 31.1668H9.91683C6.00481 31.1668 2.8335 27.9955 2.8335 24.0835V9.91683C2.8335 6.00481 6.00481 2.8335 9.91683 2.8335ZM22.6668 16.1077C22.8417 17.2867 22.6403 18.4908 22.0913 19.5488C21.5424 20.6067 20.6738 21.4647 19.6091 22.0005C18.5445 22.5364 17.338 22.7229 16.1612 22.5336C14.9844 22.3442 13.8973 21.7886 13.0545 20.9458C12.2117 20.103 11.6561 19.0159 11.4668 17.8391C11.2774 16.6624 11.4639 15.4558 11.9998 14.3912C12.5357 13.3265 13.3936 12.458 14.4516 11.909C15.5095 11.36 16.7136 11.1587 17.8927 11.3335C19.0953 11.5118 20.2087 12.0722 21.0684 12.9319C21.9281 13.7916 22.4885 14.905 22.6668 16.1077Z",
    stroke: "#E3E3E3",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.154decf2ffb035c529ee6585b824c2cc.svg";
export { ForwardRef as ReactComponent };